import React from 'react';
import { CalendarDays, CheckCircle } from 'lucide-react';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem,
  DropdownMenuTrigger, DropdownMenuLabel
} from '../../ui/dropdown-menu';
import { useTerm } from '../../../contexts/TermContext';
import { toast } from 'sonner';

const ACADEMIC_YEARS = ['2025-2026', '2026-2027', '2027-2028', '2028-2029', '2029-2030', '2030-2031'];

export function TermSelector({ user }) {
  const { academicYear, changeTerm } = useTerm();
  const canChange = ['CEO', 'Principal', 'HeadTeacher', 'Admin', 'SuperAdmin'].includes(user?.role);

  if (canChange) {
    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            className="flex items-center gap-1.5 bg-[#1565C0]/8 border border-[#1565C0]/20 rounded-md px-2.5 py-1.5 hover:bg-[#1565C0]/12 transition-colors"
            data-testid="term-selector"
          >
            <CalendarDays className="w-3.5 h-3.5 text-[#42A5F5]" />
            <span className="text-xs font-semibold text-[#1565C0] hidden sm:inline">{academicYear}</span>
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-44">
          <DropdownMenuLabel className="text-[10px] uppercase tracking-widest text-slate-400 font-semibold pb-1">
            Academic Year
          </DropdownMenuLabel>
          {ACADEMIC_YEARS.map(y => (
            <DropdownMenuItem
              key={y}
              onClick={() => { changeTerm('2025-2026', y); toast.success(`Academic year set to ${y}`); }}
              className={`cursor-pointer text-sm ${academicYear === y ? 'bg-[#1565C0]/8 font-semibold' : ''}`}
              data-testid={`set-year-${y}`}
            >
              {y}
              {academicYear === y && <CheckCircle className="w-3 h-3 ml-auto text-[#42A5F5]" />}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    );
  }

  return (
    <div className="flex items-center gap-1.5 bg-slate-50 rounded-md px-2 py-1.5">
      <CalendarDays className="w-3.5 h-3.5 text-[#42A5F5]" />
      <span className="text-xs font-semibold text-[#1565C0] hidden sm:inline">{academicYear}</span>
    </div>
  );
}
